import {
  BizTypeEnum,
  ReviewResultEnum,
  UserForegroundDomainEnum,
} from 'packages/sdks-next/growp'

export enum ReadOverMode {
  Correct = 'correct',
  Wrong = 'wrong',
  HalfCorrect = 'halfCorrect',
}

export enum QuizMode {
  Preview = 'preview',
  Answering = 'answering',
  Completed = 'completed',
  Review = 'review',
  Reviewed = 'reviewd',
  Empty = 'empty',
}

export interface CreateReviewParams {
  paperId: number
  bizId?: number
  bizType?: BizTypeEnum
  activityTaskId?: number
}

export interface CreateReviewPayload {
  questionId: number
  answerId: number
  submitterDomain: UserForegroundDomainEnum
  submitterId: number
  result?: ReviewResultEnum | null
  gainedScore?: string | null
  id?: number
}

export interface AnswerProps {
  paperId: number
  bizId?: number
  bizType?: BizTypeEnum
  activityTaskId?: number
  questionId: number
  answerId: number
  submitterDomain: UserForegroundDomainEnum
  submitterId: number
}
